import { defineCapability } from 'nest/capabilities';
import { args } from 'nest/common/args';

export const SEARCH_INPUT_EVENT_CAP = defineCapability({
  name: 'SEARCH_INPUT_EVENT_CAP' as const,
  args: {
    name: args.string(),
    value: args.anyObject(),
  },
});
